<template>
  <div>
    <v-text-field v-model="text" clearable flat hide-details placeholder="Поиск..." solo>
      <template v-slot:prepend-inner>
        <v-sheet v-if="loading" width="24" class="text-center">
          <v-progress-circular indeterminate color="primary" size="16" width="2" class="ma-auto"/>
        </v-sheet>
        <v-icon v-else>mdi-magnify</v-icon>
      </template>
    </v-text-field>
  </div>

</template>

<script>
export default {
  props: ['loading'],
  mounted() {
    let s = this.$tools.storageGet('dialogPageSearch_text');
    if (!this.$tools.isEmpty(s)) {
      this.text = s;
      this.$tools.storageSet('dialogPageSearch_text')
    }
  },
  data: () => ({
    text: null,
  }),
  watch: {
    text() {
      this.$tools.debounce(() => {
        this.$emit('update:text', this.text)
      }, 1000, 'dialogPageSearch')
    }
  }
}
</script>